import React, { useState, useRef, useEffect } from "react";
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  TextField,
  Button,
  Typography,
  Box,
  Paper,
  MenuItem,
  Select,
  InputLabel,
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
  input: {
    textAlign: 'center', // Center-align input and placeholder
  },
  customPaper :{
    padding: "20px",
    maxWidth: "80%",
    border: "8px solid rgba(244, 176, 53, 0.8)",
    backgroundColor: "rgba(245, 243, 243, 1)",
    textAlign: "center",
    marginLeft: "15px",
    borderRadius: "14px !important",
  }
});

function StopChequePaymentForm(props) {
  const classes = useStyles();
  const [selection, setSelection] = useState("single");
  const [singleValue, setSingleValue] = useState("");
  const [error, setError] = useState("");
  const [multipleValues, setMultipleValues] = useState({
    value1: "",
    value2: "",
  });
  const [isDisable, setIsDisable] = useState(false);
  const [selectedReasonKey, setSelectedReasonKey] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false); // New state for submission tracking

  // const inputRef = useRef(null);

  // useEffect(() => {
  //   // Focus the input field based on the selection
  //   if (inputRef.current) {
  //     inputRef.current.focus();
  //   }
  // }, [selection]); // Add selection as a dependency
  
  const singleInputRef = useRef(null);
  const fromInputRef = useRef(null);
  const toInputRef = useRef(null);

  useEffect(() => {
    // Focus the appropriate input field based on the selection
    if (selection === "single" && singleInputRef.current) {
      singleInputRef.current.focus();
    } else if (selection === "multiple" && fromInputRef.current) {
      fromInputRef.current.focus();
    }
  }, [selection]);
  const object = {
    "01": "Issued In Error",
    "02": "Stolen",
    "03": "Stolen Blank",
    "04": "Lost in Post",
    "05": "Per Customer Request",
    "06": "Cheque Book Request",
    "07": "Cheque Reissued",
    "08": "Paid In Cash",
    "09": "Other",
    "10": "Undelivered Cheque Book",
  };

  const reasons = Object.keys(object).map((key) => ({
    key: key,
    label: object[key],
  }));

  const handleRadioChange = (e) => {
    if (!isDisable) {
      setSelection(e.target.value);
      setSingleValue("");
      setMultipleValues({ value1: "", value2: "" });
      setSelectedReasonKey("");
      setError(""); // Clear error when switching selection
    }
  };

  const handleSingleInputChange = (e) => {
    const limit = 6;
    const inputValue = e.target.value.replace(/\D/g, "").slice(0, limit);
    setSingleValue(inputValue);

    if (inputValue.length === limit && selectedReasonKey) {
      setError("");
    }
  };

  const handleMultipleInputChange = (e) => {
    const limit = 6;
    const { name, value } = e.target;
    const inputValue = value.replace(/\D/g, "").slice(0, limit);
    setMultipleValues((prev) => ({
      ...prev,
      [name]: inputValue,
    }));

    if (
      multipleValues.value1.length === limit &&
      multipleValues.value2.length === limit &&
      selectedReasonKey
    ) {
      setError("");
    }
  };

  const handleReasonChange = (e) => {
    if (!isDisable) {
      setSelectedReasonKey(e.target.value);

      if (
        (selection === "single" && singleValue.length === 6) ||
        (selection === "multiple" &&
          multipleValues.value1.length === 6 &&
          multipleValues.value2.length === 6)
      ) {
        setError("");
      }
    }
  };

  const isSubmitEnabled =
    (selection === "single"&& selectedReasonKey) ||
    (selection === "multiple" &&
      multipleValues.value1 &&
      multipleValues.value2 &&
      selectedReasonKey);

  // const handleSubmit = () => {
  //   let data;

  //   if (
  //     selection === "single" &&
  //     selectedReasonKey &&
  //     singleValue.length === 6
  //   ) {
  //     data = {
  //       from: singleValue,
  //       to: singleValue,
  //       reason: selectedReasonKey,
  //       flag: "scp",
  //     };
  //     console.log(data);
  //     setError("");
  //     props.onSendWorkFlowSCPData({ data });
  //     setIsDisable(true);
  //     return;
  //   } else if (
  //     selection === "multiple" &&
  //     selectedReasonKey &&
  //     multipleValues.value1.length === 6 &&
  //     multipleValues.value2.length === 6
  //   ) {
  //     if ((parseInt(multipleValues.value1) > parseInt(multipleValues.value2)) || (multipleValues.value1 ===multipleValues.value2)) {
  //       setError("The 'FROM' value should not be greater than or equal the 'TO' value.");
  //       setIsDisable(false);
  //       setSingleValue("");
  //       setMultipleValues({ value1: "", value2: "" });
  //       setSelectedReasonKey("");
  //       return;
  //     }
  //     setError("");
  //     data = {
  //       from: multipleValues.value1,
  //       to: multipleValues.value2,
  //       reason: selectedReasonKey,
  //       flag: "scp",
  //     };
  //     console.log(data);
  //     props.onSendWorkFlowSCPData({ data });
  //     setIsDisable(true);
  //     return;
  //   } else {
  //     setError("Please fill in all fields correctly.");
  //     setIsDisable(false);
  //     setSingleValue("");
  //     setMultipleValues({ value1: "", value2: "" });
  //     setSelectedReasonKey("");
  //   }
  // };
  const handleSubmit = () => {
    let data;
  
    if (
      selection === "single" &&
      selectedReasonKey &&
      singleValue.length === 6
    ) {
      data = {
        from: singleValue,
        to: singleValue,
        reason: selectedReasonKey,
        flag: "scp",
      };
      console.log(data);
      setError("");
      props.onSendWorkFlowSCPData({ data });
      setIsDisable(true)
      ; // Disable button and change color to grey
      setIsSubmitted(true);
      return;
    } else if (
      selection === "multiple" &&
      selectedReasonKey &&
      multipleValues.value1.length === 6 &&
      multipleValues.value2.length === 6
    ) {
      if (
        parseInt(multipleValues.value1) > parseInt(multipleValues.value2) ||
        multipleValues.value1 === multipleValues.value2
      ) {
        setError("The 'FROM' value should not be greater than or equal to the 'TO' value.");
        setIsDisable(false);
        return;
      }
      setError("");
      data = {
        from: multipleValues.value1,
        to: multipleValues.value2,
        reason: selectedReasonKey,
        flag: "scp",
      };
      console.log(data);
      props.onSendWorkFlowSCPData({ data });
      setIsDisable(true)
      ; // Disable button and change color to grey
      setIsSubmitted(true);
      return;
    } else {
      setError("Please fill in all fields correctly.");
      setIsDisable(false);
    }
  };
  
  return (
    <Paper
      elevation={3}
      // style={{
      //   padding: "20px",
      //   maxWidth: "80%",
      //   border: "8px solid rgba(244, 176, 53, 0.8)",
      //   backgroundColor: "rgba(245, 243, 243, 1)",
      //   textAlign: "center",
      //   marginLeft: "15px",
      //   borderRadius:"14px"
      // }}
      style={{borderRadius:"20px"}}
      className={classes.customPaper}
    >
      <Typography
        variant="h5"
        style={{
          marginBottom: "20px",
          color: "#0c4da2",
          fontSize: "14px",
          fontWeight: "600",
        }}
      >
        Stop Cheque Payment
      </Typography>

      <FormControl component="fieldset" fullWidth>
        <RadioGroup row value={selection} onChange={handleRadioChange}>
          <FormControlLabel
            value="single"
            control={<Radio style={{ color: "rgba(244, 176, 53, 0.8)" }} />}
            label="Single"
          />
          <FormControlLabel
            value="multiple"
            control={<Radio style={{ color: "rgba(244, 176, 53, 0.8)" }} />}
            label="Multiple"
          />
        </RadioGroup>
      </FormControl>

      {selection === "single" && (
        <Box mt={2}>
          <TextField
            variant="outlined"
            inputRef={singleInputRef} 
            fullWidth
            placeholder="Enter Cheque Number"
            value={singleValue}
            onChange={handleSingleInputChange}
            disabled={isDisable}
            style={{
              backgroundColor: "white",
            }}
            InputProps={{
              classes: {
                input: classes.input, // Apply the custom class
              },
            }}
          />
        </Box>
      )}

      {selection === "multiple" && (
        <Box mt={2}>
           <InputLabel
          style={{
            color: "#0c4da2",
            fontSize: "14px",
            fontWeight: "600",
            marginBottom: "10px",
            textAlign:"start"
          }}
        >
         From
        </InputLabel>
          <TextField
            variant="outlined"
            name="value1"
            fullWidth
            inputRef={fromInputRef} 
            placeholder="Enter Cheque Number"
            margin="normal"
            value={multipleValues.value1}
            onChange={handleMultipleInputChange}
            disabled={isDisable}
            style={{
              backgroundColor: "white",
             

            }}
            InputProps={{
              classes: {
                input: classes.input, // Apply the custom class
              },
            }}
          />
            
           <InputLabel
          style={{
            color: "#0c4da2",
            fontSize: "14px",
            fontWeight: "600",
            marginBottom: "10px",
            textAlign:"start",
            marginTop:"10px"
          }}
        >
         To
        </InputLabel>
          <TextField
            variant="outlined"
            placeholder="Enter Cheque Number"
            name="value2"
            fullWidth
            inputRef={toInputRef} 
            margin="normal"
            value={multipleValues.value2}
            onChange={handleMultipleInputChange}
            disabled={isDisable}
            style={{
              backgroundColor: "white",
            }}
            InputProps={{
              classes: {
                input: classes.input, // Apply the custom class
              },
            }}
          
          />
        </Box>
      )}

      <Box mt={2}>
        <InputLabel
          style={{
            color: "#0c4da2",
            fontSize: "14px",
            fontWeight: "600",
            marginBottom: "10px",
          }}
        >
          Select a Reason
        </InputLabel>
        <FormControl fullWidth>
          <Select
            value={selectedReasonKey}
            onChange={handleReasonChange}
            disabled={isDisable}
            style={{
              backgroundColor: "white",
            }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                },
              },
            }}
          >
            {reasons.map((reason) => (
              <MenuItem key={reason.key} value={reason.key}>
                {reason.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {error && (
        <Typography color="error" style={{ marginTop: "10px" }}>
          {error}
        </Typography>
      )}

      <Box  mt={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={!isSubmitEnabled || isDisable}
          style={{
            backgroundColor: isSubmitted ? "grey" : "#0c4da2",
            color: "white",

            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            display: "block", // Ensure the button is treated as a block element
            marginLeft: "auto", // Center horizontally
            marginRight: "auto",
          }}
          
        >
          Submit
        </Button>
      </Box>
    </Paper>
  );
}

export default StopChequePaymentForm;
